export enum Mode {
  Read = 1,
  Write,
}
